import { useEffect, useState } from "react";
import { Link } from "react-router";

import vetDogImg from '../img/vet_dog.png';

/* ── Asset URLs ── */
const WHYCHOOSE_IMG = "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=800&auto=format&fit=crop&q=80"; // Happy dog getting examined

export default function HeyVetHomeContentPage() {
    const [symptoms, setSymptoms] = useState("");
    const [validationMsg, setValidationMsg] = useState("");

    useEffect(() => {
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
    }, []);

    const handleSearch = () => {
        if (!symptoms.trim()) {
            setValidationMsg("Por favor describe los síntomas de tu mascota.");
            return;
        }
        setValidationMsg("");
        // In a real app we'd navigate to triage form here
        alert("¡Búsqueda iniciada para: " + symptoms + "!");
    };

    return (
        <div className="heyvet-wrapper">
            {/* ═══════════════ HERO ═══════════════ */}
            <section className="hv-hero">
                <div className="hv-hero-bg-shape"></div>
                <div className="hv-container" style={{ position: "relative", zIndex: 1 }}>
                    <div className="hv-hero-layout" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 40 }}>
                        {/* Text Content */}
                        <div className="hv-hero-text" style={{ flex: "1 1 500px", maxWidth: 600 }}>
                            <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "#ECFDF5", color: "#065F46", padding: "6px 16px", borderRadius: 999, fontSize: "0.85rem", fontWeight: 700, marginBottom: 20 }}>
                                <span className="material-symbols-outlined" style={{ fontSize: 16 }}>bolt</span>
                                Atención Veterinaria 24/7
                            </div>
                            
                            <h1 className="hv-animate-fade-up" style={{ fontSize: "clamp(2.5rem, 5vw, 4rem)", fontWeight: 800, color: "#0F172A", lineHeight: 1.1, marginBottom: 24, letterSpacing: "-0.5px" }}>
                                Tu mascota merece el <span style={{ color: "#10B981" }}>mejor cuidado</span>
                            </h1>
                            
                            <p className="hv-animate-fade-up" style={{ fontSize: "1.125rem", color: "#475569", lineHeight: 1.6, marginBottom: 40, animationDelay: "0.1s" }}>
                                Obtén respuestas médicas claras y rápidas para tus perros, gatos y especies menores desde la comodidad de tu hogar.
                            </p>

                            {/* Search Box */}
                            <div className="hv-animate-fade-up" style={{ animationDelay: "0.2s" }}>
                                <div className="hv-search-box">
                                    <span className="material-symbols-outlined" style={{ color: "#10B981", fontSize: 24 }}>search</span>
                                    <input 
                                        type="text" 
                                        className="hv-search-input" 
                                        placeholder="Ej: Mi perro de 3 años tiene diarrea..."
                                        value={symptoms}
                                        onChange={(e) => setSymptoms(e.target.value)}
                                    />
                                    <button className="hv-btn hv-btn-primary" onClick={handleSearch}>
                                        Consultar
                                    </button>
                                </div>
                                {validationMsg && (
                                    <p style={{ color: "#EF4444", fontSize: "0.875rem", marginTop: 12, marginLeft: 24 }}>
                                        {validationMsg}
                                    </p>
                                )}
                            </div>
                        </div>

                        {/* Image */}
                        <div className="hv-animate-fade-up hv-hero-image" style={{ flex: "1 1 400px", animationDelay: "0.3s", position: "relative" }}>
                            <div style={{ position: "relative", borderRadius: "24px", overflow: "hidden", aspectRatio: "4/3", boxShadow: "0 25px 50px -12px rgba(16, 185, 129, 0.25)" }}>
                                <img src={vetDogImg} alt="Veterinarian examining a dog" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            </div>
                            {/* Floating Badge */}
                            <div className="hv-glass" style={{ position: "absolute", bottom: -20, left: -20, padding: "16px 24px", borderRadius: "16px", display: "flex", alignItems: "center", gap: 12 }}>
                                <div style={{ width: 44, height: 44, background: "#10B981", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>
                                    <span className="material-symbols-outlined">health_and_safety</span>
                                </div>
                                <div>
                                    <p style={{ margin: 0, fontWeight: 800, color: "#0F172A", fontSize: "1.1rem" }}>100% Certificados</p>
                                    <p style={{ margin: 0, color: "#475569", fontSize: "0.85rem" }}>Médicos Veterinarios Zootecnistas</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══════════════ STATS ═══════════════ */}
            <section style={{ position: "relative", zIndex: 10, padding: "0 24px" }}>
                <div className="hv-container hv-stats-wrapper">
                    {[
                        { num: "5k+", label: "Mascotas Atendidas", icon: "pets" },
                        { num: "24/7", label: "Disponibilidad", icon: "schedule" },
                        { num: "50+", label: "Especialistas Vet", icon: "badge" },
                        { num: "4.9", label: "Estrellas (Padres Felices)", icon: "star" },
                    ].map((stat, i) => (
                        <div key={i} className="hv-stat-item">
                            <span className="material-symbols-outlined" style={{ fontSize: 32, color: "#10B981", marginBottom: 8 }}>{stat.icon}</span>
                            <div className="hv-stat-number">{stat.num}</div>
                            <div style={{ color: "#475569", fontSize: "0.95rem", fontWeight: 600 }}>{stat.label}</div>
                        </div>
                    ))}
                </div>
            </section>

            {/* ═══════════════ SERVICES ═══════════════ */}
            <section id="services" style={{ padding: "100px 0 80px", background: "white" }}>
                <div className="hv-container">
                    <div style={{ textAlign: "center", marginBottom: 60 }}>
                        <h2 style={{ fontSize: "clamp(2rem, 4vw, 2.5rem)", fontWeight: 800, color: "#0F172A", marginBottom: 16 }}>
                            Nuestros Servicios
                        </h2>
                        <p style={{ fontSize: "1.1rem", color: "#64748B", maxWidth: 600, margin: "0 auto" }}>
                            Cobertura médica integral para el bienestar de perros, gatos y animales exóticos.
                        </p>
                    </div>

                    <div className="hv-services-grid">
                        {[
                            { icon: "stethoscope", title: "Consulta General", desc: "Revisión completa de salud, diagnóstico y tratamiento de enfermedades comunes." },
                            { icon: "vaccines", title: "Vacunación", desc: "Esquemas completos de vacunación y desparasitación para cachorros y adultos." },
                            { icon: "medical_services", title: "Emergencias", desc: "Atención prioritaria y orientación inmediata en casos críticos 24/7." },
                            { icon: "restaurant", title: "Nutrición Clínica", desc: "Planes de alimentación especializados para control de peso o patologías." },
                        ].map((s, i) => (
                            <div key={i} className="hv-service-card">
                                <div className="hv-service-icon-wrap">
                                    <span className="material-symbols-outlined" style={{ fontSize: 32 }}>{s.icon}</span>
                                </div>
                                <h3 style={{ fontSize: "1.2rem", fontWeight: 700, color: "#0F172A", marginBottom: 12 }}>{s.title}</h3>
                                <p style={{ fontSize: "0.95rem", color: "#64748B", lineHeight: 1.6 }}>{s.desc}</p>
                                <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
                                    <span style={{ width: 32, height: 32, borderRadius: "50%", background: "#F8FAFC", display: "flex", alignItems: "center", justifyContent: "center", color: "#10B981" }}>
                                        <span className="material-symbols-outlined" style={{ fontSize: 18 }}>arrow_forward</span>
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══════════════ WHY CHOOSE US ═══════════════ */}
            <section id="why-us" style={{ padding: "80px 0", background: "#F8FAFC", borderTop: "1px solid #F1F5F9" }}>
                <div className="hv-container hv-why-wrapper" style={{ display: "flex", alignItems: "center", gap: 60 }}>
                    {/* Content */}
                    <div style={{ flex: 1 }}>
                        <span style={{ display: "inline-block", background: "#ECFDF5", color: "#065F46", padding: "4px 12px", borderRadius: 999, fontSize: "0.85rem", fontWeight: 700, marginBottom: 16 }}>
                            Beneficios
                        </span>
                        <h2 style={{ fontSize: "clamp(2rem, 4vw, 2.5rem)", fontWeight: 800, color: "#0F172A", marginBottom: 24, lineHeight: 1.2 }}>
                            ¿Por qué elegir HeyVet?
                        </h2>
                        <p style={{ fontSize: "1.1rem", color: "#475569", marginBottom: 40, lineHeight: 1.6 }}>
                            Combinamos la inmediatez de la tecnología con la experiencia y empatía clínica de nuestros médicos veterinarios titulados.
                        </p>
                        
                        <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
                            {[
                                { icon: "speed", title: "Atención Inmediata", desc: "Sin salas de espera llenas de estrés para tu mascota." },
                                { icon: "verified", title: "Médicos Verificados", desc: "Tu mascota solo será atendida por profesionales certificados (MVZ)." },
                                { icon: "history", title: "Historial Clínico Digital", desc: "Todo el expediente de tu mascota a salvo y accesible siempre." },
                            ].map((item, i) => (
                                <div key={i} style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
                                    <div style={{ width: 48, height: 48, borderRadius: "12px", background: "white", display: "flex", alignItems: "center", justifyContent: "center", color: "#10B981", flexShrink: 0, boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)" }}>
                                        <span className="material-symbols-outlined">{item.icon}</span>
                                    </div>
                                    <div>
                                        <h4 style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0F172A", marginBottom: 4 }}>{item.title}</h4>
                                        <p style={{ fontSize: "0.95rem", color: "#64748B", margin: 0 }}>{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Image */}
                    <div className="hv-why-img-container" style={{ flex: 1, position: "relative" }}>
                        <div style={{ position: "relative", borderRadius: "24px", overflow: "hidden", aspectRatio: "4/5", boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.15)" }}>
                            <img src={WHYCHOOSE_IMG} alt="Happy dog examined by vet" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            
                            <div className="hv-glass" style={{ position: "absolute", top: 30, right: -20, padding: "12px 20px", borderRadius: "12px", display: "flex", alignItems: "center", gap: 12, transform: "translateX(-20px)" }}>
                                <span className="material-symbols-outlined" style={{ color: "#F59E0B", fontSize: 24 }}>emergency</span>
                                <span style={{ fontWeight: 700, color: "#0F172A" }}>Respuesta <br/>en minutos</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══════════════ CTA FINAL ═══════════════ */}
            <section style={{ background: "#065F46", padding: "100px 24px", textAlign: "center", position: "relative", overflow: "hidden" }}>
                <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, opacity: 0.1, backgroundImage: "radial-gradient(#10B981 1px, transparent 1px)", backgroundSize: "30px 30px" }}></div>
                <div style={{ position: "relative", zIndex: 1, maxWidth: 650, margin: "0 auto" }}>
                    <span className="material-symbols-outlined" style={{ fontSize: 48, color: "#10B981", marginBottom: 24 }}>favorite</span>
                    <h2 style={{ fontSize: "clamp(2.5rem, 5vw, 3.5rem)", fontWeight: 800, color: "white", marginBottom: 24, lineHeight: 1.1 }}>
                        ¿Listo para cuidar a tu mejor amigo?
                    </h2>
                    <p style={{ fontSize: "1.1rem", color: "#A7F3D0", marginBottom: 40, lineHeight: 1.6 }}>
                        Únete a los miles de dueños que confían la salud de sus mascotas en HeyVet todos los días.
                    </p>
                    <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
                        <button className="hv-btn" style={{ background: "white", color: "#065F46", padding: "14px 32px", fontSize: "1.1rem" }}>
                            Hablar con un Veterinario
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
}
